import type { HTMLAttributes } from 'react'

type Surface = 'default' | 'muted' | 'warning' | 'danger' | 'neutral'

const surfaceClasses: Record<Surface, string> = {
  default: 'bg-white dark:bg-navy/20 border-carolina/[0.12] dark:border-carolina/[0.10]',
  muted: 'bg-paper dark:bg-navy/30 border-carolina/[0.12] dark:border-carolina/[0.10]',
  warning: 'bg-yellow-dark/[0.06] dark:bg-yellow/[0.06] border-yellow-dark/30 dark:border-yellow/20',
  danger: 'bg-red-400/[0.04] dark:bg-red-400/[0.04] border-red-400/[0.15] dark:border-red-400/[0.10]',
  neutral: 'bg-ink/[0.03] dark:bg-cream/[0.03] border-ink/[0.08] dark:border-cream/[0.06]',
}

const baseClasses =
  'rounded-xl border overflow-hidden shadow-[0_2px_12px_rgba(0,0,0,0.04)] dark:shadow-[0_2px_12px_rgba(0,0,0,0.2)]'

const hoverClasses =
  'hover:border-carolina/30 dark:hover:border-carolina/20 hover:shadow-[0_4px_20px_rgba(0,0,0,0.08)] dark:hover:shadow-[0_4px_20px_rgba(0,0,0,0.4)] transition-all duration-200'

type CardProps = {
  surface?: Surface
  hoverable?: boolean
} & HTMLAttributes<HTMLDivElement>

export function Card({
  surface = 'default',
  hoverable = false,
  className = '',
  ...props
}: CardProps) {
  return (
    <div
      data-component="Card"
      className={`${baseClasses} ${surfaceClasses[surface]} ${hoverable ? hoverClasses : ''} ${className}`}
      {...props}
    />
  )
}
